import Button from '@strava/ui/Button';
import React, { useEffect, useRef } from 'react';
import clsx from '@strava/ui/clsx';
import Spinner from '@strava/ui/Spinner';
import PropTypes from 'prop-types';
import styles from './ActionButton.scss';

export const ACTIONS = Object.freeze({
  back: 'back',
  next: 'next',
  approved: 'approved', // Strava::AthleteConsents:PermissionTypes.APPROVED_STRING
  denied: 'denied' // Strava::AthleteConsents:PermissionTypes.DENIED_STRING
});

const ActionButton = ({
  onClick,
  className,
  children,
  isProcessing,
  isDisabled,
  variant,
  focus,
  ...options
}) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current && focus) {
      ref.current.focus();
    }
  }, [focus]);

  return (
    <Button
      className={clsx(styles.ctaButton, className)}
      variant={variant}
      onClick={onClick}
      type="button"
      data-cy="onboarding-next-step-btn"
      disabled={isProcessing || isDisabled}
      ref={ref}
      {...options}
    >
      {isProcessing && (
        <div className={styles.spinner}>
          <Spinner />
        </div>
      )}
      <div className={clsx(isProcessing && styles.hidden)}>{children}</div>
    </Button>
  );
};

ActionButton.defaultProps = {
  isProcessing: false,
  isDisabled: false,
  className: null,
  variant: 'primary',
  focus: false
};

ActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    'default',
    'primary',
    'primary-outline',
    'secondary',
    'icon',
    'text'
  ]),
  className: PropTypes.string,
  isProcessing: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  focus: PropTypes.bool
};

export default ActionButton;
